/*
  专业版交易页面相关接口
 */
import request from './request';
// import request from "./request"
import md5 from 'js-md5';
export const tradeApi = {
  // 当前委托
  serverGetEntrustOrderList(data) {
    let _data = {
      ...data,
      status: 0, // 0 = current order, 1 = order history (matched & cancelled)
    };
    // delete _data.token;
    return request({
      // url: `/v2/s/trade/order/entrusts/${data.symbol}/${data.current}/${data.size}`,
      // url: '/v2/t/entrust/pending',
      url: '/order/list',
      method: 'get',
      // headers: {
      //   'Authorization': data.token,
      // },
      params: _data,
    });
  },
  // 历史委托订单
  serverGetTurnoverOrderList(data) {
    let _data = {
      ...data,
      status: 1, // 0 = current order, 1 = order history (matched & cancelled)
    };
    // delete _data.token;
    return request({
      // url: `/v2/s/trade/order/history/${data.symbol}/${data.current}/${data.size}`,
      // url: '/v2/t/entrust/history',
      url: '/order/list',
      method: 'get',
      // headers: {
      //   'Authorization': data.token,
      // },
      params: _data,
    });
  },
  // 币币交易 委托下单
  serverCreateOrder(data) {
    let _data = {
      price: data.price,
      symbol: data.symbol,
      type: data.type,
      volume: data.volume,
    };
    if (data.paymentPassword) {
      _data.paymentPassword = md5(data.paymentPassword);
    }
    return request({
      url: '/v2/t/entrust',
      method: 'post',
      headers: {
        Authorization: data.token,
      },
      data: _data,
    });
  },
  // 撤销委托
  serverCancelOrder(orderId) {
    return request({
      // url: `/v2/s/trade/order/entrusts/${orderId}`,
      url: '/order/cancel',
      method: 'put',
      data: {
        ...orderId,
      },
    });
  },
  // 撤销所有委托
  cancelAllOrder(pair) {
    return request({
      url: '/order/cancel/all',
      method: 'put',
      data: {
        pair,
      },
    });
  },
  // 获取当前用户当前市场 可交易额度
  getUserAccount(symbol, token) {
    return request({
      // url: '/v2/s/user/account/asset/' + symbol,
      url: '/v2/account/asset/' + symbol,
      method: 'get',
      headers: {
        Authorization: token,
      },
    });
  },
  // 个人收藏交易市场信息
  serverFavorite(token) {
    return request({
      url: '/v2/s/trade/market/favorite',
      method: 'get',
      headers: {
        Authorization: token,
      },
    });
  },

  /**
   * 获取深度数据
   * @param symbol 交易市场名称
   * @param mergeType 合并深度
   * @returns {AxiosPromise}
   */
  getDepth(symbol, mergeType) {
    return request({
      url: `https://dev-grx-api.usdp.io/trade/list?pair=ETHUSDT&interval=1MN&depthGroup=D3`,
      method: 'get',
    });
  },
  getDepthData(pair, depthGroup) {
    return request({
      url: '/trade/list',
      method: 'get',
      params: {
        pair,
        depthGroup,
      },
    });
  },
  getTradeList(params) {
    return request({
      url: '/trade/list',
      method: 'get',
      params: params,
    });
  },
  // 获取最新成交列表
  getTrades(symbol) {
    // return request({
    //   url: `/trade/list?pair=BTCUSDT`, // `/v2/s/market/deals/${symbol}`,
    //   method: 'get',
    // });

    return request({
      url: `/trade/list?pair=BTCUSDT`, // `/v2/s/market/deals/${symbol}`,
      method: 'get',
    });
  },
  // 获取深度图数据
  getDepthGraph() {
    return request({
      url: `https://dev-grx-api.usdp.io/trade/list?pair=ETHUSDT&interval=1MN&depthGroup=D3`,
      method: 'get',
    });
  },
  // 获取用户收藏的交易市场列表
  getFavorites() {
    return request.get('/v2/s/market/favorites');
  },
  /**
   * 收藏交易市场
   * @param symbols 交易对symbol，需为一个数组
   */
  collectMarket(symbols) {
    return request.post('/v2/s/market/favorites', {
      symbols: symbols,
    });
  },
  placeOrder(data) {
    let _data = {
      userId: data.userId /* need to remove after need access token */,
      pair: data.pair,
      side: data.side,
      price: data.price,
      volume: data.volume,
      orderType: data.orderType,
      txnPwd: data.txnPwd,
    };

    return request({
      url: '/order/place',
      method: 'post',
      data: _data,
    });
  },
  getExchangeObject(pair, interval, depthGroup) {
    return request({
      url: `/trade/list`,
      method: 'get',
      params: {
        pair,
        interval,
        depthGroup,
      },
    });
  },
  getTradeDetail(data) {
    return request({
      url: `/trade/detail`,
      method: 'get',
      params: {
        ...data,
      },
    });
  },
};
